(() => {
  angular
    .module('app.components')
    .directive('panelSidebar', ['$sce',
      ($sce) => ({
        restrict: 'E',
        scope: {
          open: "=",
          freeze: "@"
        },
        transclude: true,
        controller: ['$scope', ($scope) => {
          $scope.onToggle = () => {
            $scope.open = !$scope.open;
            if ($scope.freeze) {
              $('body').toggleClass('freeze');
            }
          }
        }],
        templateUrl: $sce.trustAsResourceUrl('/assets/js/app/components/panels/panel.sidebar.template.html'),
      })
    ]);
})();
